module.exports = __webpack_public_path__ + "static/media/dashboard_down.2f507e52.svg";